import * as React from "react"

const TourPrice = ({ currency, price, pricingBasis }) => {
  if (!price || price === "0") {
    return "Ask";
  }
  let currencyFormat = currency?.includes("JPY") ? 
  new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' })
  : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })

  return (
    <>{currency} {currencyFormat.format(price)}
    {pricingBasis && <span className="text-gray-700 font-thin text-sm ml-2">{pricingBasis}</span>}
    </>
  )
};

export default TourPrice;
